import React from "react";
class Form extends React.Component {
  state = { formValue: "" };
  handleChange = (e) => {
    this.setState({ formValue: e.target.value });
  };
  handleKeyPress = (e) => {
    let url = `https://source.unsplash.com/400x400/?${this.state.formValue}`;
    if (e.key === "Enter") {
      this.props.searchImg(url, this.state.formValue);
      this.setState({ formValue: "" });
    }
  };
  render() {
    return (
      <div className="form">
        <label htmlFor="search-photo">Search Your Favorite Pictures</label>
        <input
          type="text"
          className="input-field"
          id="search-photo"
          value={this.state.formValue}
          onChange={(e) => this.handleChange(e)}
          onKeyDown={this.handleKeyPress}
          autoFocus
        />
      </div>
    );
  }
}
export default Form;
